export default theme => ({
  container: {
    position: 'relative',
  },
});
